export default "__VITE_ASSET__c31ac325__"